import * as React from 'react';
import { FC } from 'react';

import Slide, { SlideProps } from '@mui/material/Slide';
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar';

import DupontAlert from './../DupontAlert';
import { ToastMessage } from './useToast';

const SlideTransition = (props: SlideProps) => <Slide {...props} direction='left' />;

export type ToastStyle = Omit<SnackbarProps, 'TransitionProps' | 'onClose' | 'open' | 'children' | 'message'>;

export type ToastProps = {
  message: ToastMessage;
  onExited: () => void;
} & ToastStyle;

export const Toast: FC<ToastProps> = ({ message, onExited, autoHideDuration, ...props }) => {
  const [open, setOpen] = React.useState(true);

  const handleClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      key={message.key}
      open={open}
      onClose={handleClose}
      TransitionProps={{ onExited }}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={autoHideDuration ?? 3000}
      {...props}
    >
      <DupontAlert severity={message.severity} onClose={handleClose}>
        {message.message}
      </DupontAlert>
    </Snackbar>
  );
};
